<template>
    <div class="d-flex justify-content-between">
        <router-link class="back-route h3" ref="backBtn" @click="backHandler" to="#">
            <img src="../../../../assets/images/back.svg" alt="back" height="19">
            {{title}}
        </router-link>
        <span id="defaultUser" class="designDefaultUser">Please Make Sure You Step on All Questions Tabs</span>
        <a v-if="!isEventEnded" class="submit-btn btn-container text-decoration-none" @mouseover="showDefaultUser" @mouseleave="hideDefaultUser"
           :class="{'not-allow': this.template.steps > this.template.viewCounter}" @click="sumitHandler(false)">Submit</a>
    </div>

    <ConfirmationModal v-if="this.exitFlag || this.confirmModal" :message="this.confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
</template>

<script>
    import {computed, defineAsyncComponent} from "vue";
    import repository from "../../../../api-services/repository";

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../../components/ConfirmationModal')
    );
    export default {
        name: 'pageHeader-component',
        components: {ConfirmationModal},
        data() {
            return {
                intervalID: null,
                exitFlag: false,
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },

        async updated() {
            if(this.isEventTimeOut){
                await this.$store.dispatch('setAnswersFlag', false);
                await this.$store.dispatch('setErrorModal', true);
                await this.$store.dispatch('setErrorMessage', 'Time Out');
                clearInterval(this.intervalID);
                console.log('Time Out')

                setTimeout(async () => {
                    await this.$router.push({path:'/' + this.backeUrl})
                }, 3000)

            } else if(this.isEventEnded){
                await this.$store.dispatch('setAnswersFlag', false);
                console.log('submit-timeout')
                await this.sumitHandler(true);
            }
        },
        async mounted() {
            console.log('pageHeader')
            if(this.isEventEnded){
                console.log('pageHeader1')
                await this.$store.dispatch('setAnswersFlag', false);
                this.autoSave(true);
                await this.$router.push({path:'/' + this.backeUrl})
            }else{
                console.log('pageHeader2')
                await this.$store.dispatch('setAnswersFlag', true);
                await this.$store.dispatch('setConfirmModal', false);

                console.log('title => ', this.answers)
                this.intervalID = setInterval(this.autoSave,30000, false );
            }

        },
        props: ['title', 'template', 'userAnswers', 'isEventEnded', 'isEventTimeOut', 'backeUrl'],
        methods: {
            showDefaultUser() {
                if(this.template.steps > this.template.viewCounter){
                    let message = document.getElementById('defaultUser');
                    message.style.display = 'block';
                }
            },
            hideDefaultUser (){
                if(this.template.steps > this.template.viewCounter){
                    let message = document.getElementById('defaultUser');
                    message.style.display = 'none';
                }
            },
            async sumitHandler(backFlag = false) {
                let response = null;
                let data = {};
                if(backFlag || this.template.steps === this.template.viewCounter){
                    await this.$store.dispatch('setAnswersFlag', false);
                    data = await this.formatData(true);
                    console.log("auto save => ", data, this.backeUrl)
                    response = await repository.saveUserAnswers(data);
                    await this.$store.dispatch('setSuccessModal', true);
                    await this.$store.dispatch('setSueccessMessage', 'Answers submited');
                    // await this.$store.dispatch('activeTap', 'templates');
                    clearInterval(this.intervalID);
                    await this.$router.push({path:'/' + this.backeUrl});
                }else{
                    console.log('no submit');
                    console.log('this.template.steps => ', this.template.steps);
                    console.log('this.template.viewCounter => ', this.template.viewCounter);
                }

            },
            async autoSave(isSubmited) {
                let response = null;
                let data = {};
                if (this.template.changeFlag){
                    data = this.formatData(isSubmited);
                    await this.$store.dispatch('setAnswersFlag', true);
                    console.log("auto save => ", data)
                    response = await repository.saveUserAnswers(data);
                    if (response !== null){
                        console.log({response});
                        this.template.changeFlag = false;
                    }
                }

            },
            async backHandler() {
                if(this.isEventEnded){
                    await this.$store.dispatch('setAnswersFlag', false);
                    await this.$router.push('/' + this.backeUrl);
                }else{
                    this.exitFlag = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to exit and save all answers?');
                }

            },
            async confirmModalHandler(e) {
                this.exitFlag = false;
                if(e){
                    this.sumitHandler(true);
                    await this.$router.push('/' + this.$store.state.settings.currentRoute);
                }else{
                    await this.$store.dispatch('setConfirmModal', false);
                }
            },
            formatData(isSubmited){

                let formatedData = {
                    competition_training_id: +this.$route.params.id,
                    isSubmited:isSubmited,
                    answers: [],
                    slides: [],
                };

                this.userAnswers.answers.forEach((answer) =>{
                    formatedData.answers.push({
                        'answer_id': +answer.id,
                        'value': answer.value,
                    })
                });

                this.userAnswers.slides.forEach((slide) =>{
                    formatedData.slides.push({
                        'slide_attachment_id': +slide.id ? +slide.id : +slide.slide_attachment_id,
                        'order': +slide.order,
                        'category_id': slide.category_id
                    })
                });

                return formatedData;
            }
        }
    }
</script>

<style scoped>

    .designDefaultUser{
        right: 210px;
        text-align: center;
        display: none;
        position: absolute;
        top: 100px;
        width: 20%;
        font-size:12px;
        background-color: #021A24;
        color: #fff;
        padding: 0.8em;
        border-radius: 10px;
    }

    .not-allow{
        cursor: not-allowed !important;
        opacity: 0.8;
    }
    .submit-btn {

        cursor: pointer;
    }
</style>